import { permissionSettingRequiredLevelList } from '@/constants/userPermissionSetting/permissionSettingRequiredLevelList';
import { getTransformedPermissionList } from '@/vuex-store/user-permission-setting-dialog/getterUtil';
import { userLevelCode } from '@/constants/userLevel';
import { objDeepCompare } from '@/utils/object';
const getters = {
    isDialogOpen: ({ dialogDetail }) => !!dialogDetail.userInfo,
    /** 다이얼로그 정보의 유저Id 값 */
    getterTargetUserId: ({ dialogDetail }) => dialogDetail.userInfo?.userId,
    /** 다이얼로그 정보의 유저Level 값 */
    getterTargetUserLevel: ({ dialogDetail }) => dialogDetail.userInfo?.level,
    /** 사용자 권한(0502) 변경 가능한지 */
    getterIsChange0502PermissionAvailable: ({ dialogDetail }, _g, _rs, rootGatter) => {
        const userLevel = rootGatter['user/userLevel'];
        const targetLevel = dialogDetail.userInfo?.level;
        if (!targetLevel) {
            return false;
        }
        if (userLevel !== userLevelCode[42].value) {
            return false;
        }
        // @ts-ignore
        if (!permissionSettingRequiredLevelList.includes(targetLevel)) {
            return false;
        }
        return true;
    },
    /** 사용자 권한 목록을 view를 위하여 구조화 한 값 */
    getterUserPermissionList: ({ userPermissionList }) => getTransformedPermissionList(userPermissionList),
    /** 테이블 최초 열림 상태 - 오리진 데이터를 참조함으로서 호출 시 1회 연산 유도 */
    getterExpandedCodeList: ({ originData }) => originData
        .filter((item) => item.isDepth2)
        .map((item) => item.code),
    getterIsChanged: ({ originData, userPermissionList, }) => !objDeepCompare(originData, userPermissionList),
};
export default getters;
